import { render } from "./Vote.vue?vue&type=template&id=4cbd19cf&scoped=true"
import script from "./Vote.vue?vue&type=script&lang=js"
export * from "./Vote.vue?vue&type=script&lang=js"

import "./Vote.vue?vue&type=style&index=0&id=4cbd19cf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4cbd19cf"

export default script